import PaymentFormFragment, { PaymentFormFragmentProps } from './payment-form-fragment';
import Spacer, { SpacerVariant } from '@/common/components/spacer';
import BillingAddressFormFragment, {
  BillingAddressFormFragmentProps,
} from './billing-address-form-fragment';
import StripePaymentFormFragment, {
  StripePaymentFormFragmentProps,
} from './stripe-payment-form-fragment';

export interface PaymentAddressFormFragmentProps
  extends BillingAddressFormFragmentProps,
    Partial<PaymentFormFragmentProps>,
    StripePaymentFormFragmentProps {
  spacerGapVariant?: SpacerVariant;
  shouldUseStripe?: boolean;
}

export default function PaymentAddressFormFragment({
  // Base props
  showCancellationBlurb,
  shouldUseStripe = false,
  // Adyen Payment props
  paymentError,
  adyenOriginKey,
  adyenJsSrc,
  paymentMethodConfiguration,
  shouldAllowStoredPaymentMethods,
  // Address props
  defaultAddress,
  addressErrors,
  smartyStreetsEmbeddedKey,
  spacerGapVariant = 'height24',
}: PaymentAddressFormFragmentProps) {
  return (
    <>
      {shouldUseStripe ? (
        <StripePaymentFormFragment
          showCancellationBlurb={showCancellationBlurb}
          paymentError={paymentError}
        />
      ) : (
        <PaymentFormFragment
          showCancellationBlurb={showCancellationBlurb}
          adyenOriginKey={adyenOriginKey ?? ''}
          adyenJsSrc={adyenJsSrc ?? ''}
          paymentMethodConfiguration={paymentMethodConfiguration}
          paymentError={paymentError}
          shouldAllowStoredPaymentMethods={shouldAllowStoredPaymentMethods ?? false}
        />
      )}

      <Spacer variant={spacerGapVariant} />

      <BillingAddressFormFragment
        defaultAddress={defaultAddress}
        addressErrors={addressErrors}
        smartyStreetsEmbeddedKey={smartyStreetsEmbeddedKey}
      />
    </>
  );
}
